exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*Style scrollbar*/\r\n/* width */\r\n::-webkit-scrollbar {\r\n\twidth: 10px;\r\n}\r\n\r\n/* Track */\r\n::-webkit-scrollbar-track {\r\n\tbox-shadow: inset 0 0 5px #F0F2F4;\r\n\tborder-radius: 10px;\r\n}\r\n\r\n/* Handle */\r\n::-webkit-scrollbar-thumb {\r\n\tbackground: #00B4DC;\r\n\tborder-radius: 10px;\r\n}\r\n\r\n/* Handle on hover */\r\n::-webkit-scrollbar-thumb:hover {\r\n\tbackground: #00B4DC;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// D:/GITHUB/F210/V18/rec_ng_renta210v18/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!D:/GITHUB/F210/V18/rec_ng_renta210v18/node_modules/postcss-loader?{"ident":"postcss"}!D:/GITHUB/F210/V18/rec_ng_renta210v18/src/assets/styles/scrollbar.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/assets/styles/scrollbar.css
// module chunks = styles